import { effect, signal, Signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { DateConst } from 'app/shared/date.const';
import { debounceTime } from 'rxjs';

export class FacetUtils {
  static hronologicalSort<T extends { start: string; end?: string }>(facets: T[]): T[] {
    return facets.sort((a, b) => {
      if (a.start === null) {
        return 1;
      }
      if (b.start === null) {
        return -1;
      }

      if (a.start !== b.start) {
        return +DateConst.getYear(a.start) - +DateConst.getYear(b.start);
      }
      if (a.end === null) {
        return 1;
      }
      if (b.end === null) {
        return -1;
      }
      return +DateConst.getYear(a.end) - +DateConst.getYear(b.end);
    });
  }

  static debouncedSignal<T>(input: Signal<T>, timeOutMs = 0): Signal<T> {
    return toSignal(toObservable(input).pipe(debounceTime(timeOutMs)), { initialValue: input() });
  }
}
